import * as moment from 'moment';
import { combineLatest, from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseProductService } from '../-base-product.service';
import { UserService } from '../../user/user.service';
import { BaseProductStateModel } from '../base-product-state.models';
import { BaseProductInterviewData } from '../_base-product-interview-data';
import { ProductNameMedicaid, ProductNamePartialToFull } from './medicaid.state.models';


export interface IReasonsList {
    reasons: string[];
}

export class MedicaidInterviewData extends BaseProductInterviewData {

    constructor(
        productService: BaseProductService<BaseProductStateModel>,
        userService: UserService
    ) {
        super(productService, userService);
    }

    getNotQualifiedItems(): Observable<string[]> {
        return of([
            'Over Income'
            , 'Over Assets'
        ]);
    }

    generateNotInterestedItems(): Observable<string[]> {
        const notInterestedComplete$: Observable<IReasonsList> =
            from(this.productService.configsService
                .resolve('COMPLETE_MEDICAID_CASE_CODES', {TenantId : this.productService.memberService.tenantIdSync})
            ).pipe(
                map((result: any) => {
                    if(!result || result.length == 0) {
                        return { reasons: [] };
                    }

                    return { reasons: JSON.parse(result[0]).reasons };
                })
            );

        return combineLatest([notInterestedComplete$, this.userService.currentRole$]).pipe(map(([reasonsObj, userRole]) => {

            const reasons: string[] = reasonsObj.reasons;

            let stageName: string = '';

            switch (this.productService.currentCaseSync?.productName.toUpperCase()) {
                case ProductNameMedicaid:
                    {
                        stageName = 'PREPARINGAPPLICATION';
                        break;
                    }
                case ProductNamePartialToFull:
                    {
                        stageName = 'INPROGRESS';
                        break;
                    }
            }

            if (stageName.length > 0) {

                const stage = this.productService.caseStageSync;
                const originDate = stage.createdOn && moment(stage.createdOn);
                const days = originDate && moment().diff(originDate, 'day');

                // added source check for case stages where the stage name is missing for backward compatibility
                if ((stage.source?.toUpperCase() == stageName || stage.name?.toUpperCase() == stageName) && (userRole.isSupervisor || days >= 90)) {
                    reasons.push('Non-Responsive');
                }
            }

            return reasons.sort();
        }));
    }

}
